import(/* webpackMode: "eager" */ "/vercel/path0/app/extractor/page.tsx");
